import script from "./ChevronArrowRight1Icon.vue?vue&type=script&setup=true&lang=js"
export * from "./ChevronArrowRight1Icon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__